import { useTranslation } from 'react-i18next';
import { useState } from 'react';
const ListaNoticias = ({ noticias, ruta, lang, config }) => {

    const { t } = useTranslation();

    var preidioma = ""
    if (lang != 'es') preidioma = lang + "/";

    const formatearFecha = (fechaString) => {
        const fecha = new Date(fechaString);
        return new Intl.DateTimeFormat('es-ES', {
            month: 'short',  // "Ene", "Feb", etc.
            day: '2-digit',  // "01", "02", etc.
            year: 'numeric'  // "2026"
        }).formatToParts(fecha)
            .map(({ type, value }) => {
                if (type === 'literal') return value;
                return value;
            })
            .join(' ');
    };

    const [expandedIds, setExpandedIds] = useState({}); // { id1: true, id2: false }

    const toggleExpand = (id) => {
        setExpandedIds(prev => ({
            ...prev,
            [id]: !prev[id]
        }));
    };

    return (
        <div className="container">
            <h2 className="mx-auto mb-6 text-center h5 mx-850">{t("Consulta las últimas noticias de Vale Suites y mantente informado de nuestras últimas novedades")}</h2>
            {noticias.map((unanoticia, index) => {
                const isExpanded = expandedIds[unanoticia.id] || false;
                return (
                    <div key={unanoticia.id || index}>
                        <press-room-item-template>
                            <div className="row mb-md-6">
                                <div className="col-md-6">
                                    <figure className="me-lg-5 mh-lg-280">
                                        {
                                            unanoticia.imagen ?
                                                <img className="w-100" src={`${ruta}/blog/${unanoticia.id}/${unanoticia.imagen}`} />
                                                :
                                                <img className="w-100" src="/images/web/bedloop-nofoto.png" alt={"Blog - " + index} />
                                        }
                                    </figure>
                                </div>
                                <div className="col-md-6 d-flex flex-column justify-content-center align-items-start">
                                    <h3 style={{ cursor: "pointer" }}> {unanoticia.eltitulo} </h3>
                                    <div className="col-md-auto">
                                        <div className={`js-txtoverflow overflowing ${isExpanded ? 'show' : ''}`} style={{ WebkitLineClamp: isExpanded ? "unset" : "3" }}>
                                            <span className="text-sm">{formatearFecha(unanoticia.fecha_publica)}</span>
                                            <p className="text-gray" dangerouslySetInnerHTML={{ __html: unanoticia.elsubtitulo }}>
                                            </p>
                                            <p className="text-gray" dangerouslySetInnerHTML={{ __html: unanoticia.ladesccorta }}>
                                            </p>
                                        </div>
                                        <button type="button" className="btn btn-outline-primary btn-txtoverflow" onClick={() => toggleExpand(unanoticia.id)} style={{ display: "block" }} >{isExpanded ? t("VER MENOS") : t("VER MÁS")}</button>
                                        {/* <ul className="row-gap-3 mt-0 o-list-features justify-content-start mt-md-4">
                                        <li>
                                            <a>
                                                <strong>DESCARGAR NOTICIA</strong>
                                            </a>

                                        </li>
                                        <li>
                                            <a>
                                                <strong>DESCARGAR IMÁGENES</strong>
                                            </a>

                                        </li>
                                    </ul>*/}
                                    </div>
                                </div>
                            </div>
                        </press-room-item-template>
                    </div >
                )
            })
            }
        </div >
    );
}

export default ListaNoticias
